import request from '@/utils/request'

const prefix = '/django_rest/client-admin/major-management'

export default {
  getMajorManagementList (params) {
    return request.get(`${prefix}/`, { params })
  },
  createMajor (params) {
    return request.post(`${prefix}/`, params)
  },
  updateMajor (params) {
    return request.put(`${prefix}/`, params)
  }
}
